import React from "react";
import { Column, Image, useTimeout } from "@hex-insights/core";
import { useActivePageRegistration, useHistory } from "@hex-insights/router";
import { StaticURLs } from "@s-i-s-i/see-learning.shared";
import { homePageInfo } from "../../Home/pageinfo";
import { OnboardingLayout } from "../Components";
import { onboardingSuccessPageInfo } from "./pageinfo";

export function OnboardingSuccessPage() {
	useActivePageRegistration(onboardingSuccessPageInfo);

	const { setTimeout } = useTimeout();
	const history = useHistory();
	React.useEffect(() => {
		setTimeout(() => {
			history.push(homePageInfo.to);
		}, 2500);
	}, [setTimeout, history]);

	return (
		<OnboardingLayout page="index">
			<Column justify="center" align="center" style={{ height: "100%" }}>
				<Image
					src={StaticURLs.Images.studentBoy1}
					sizing="contain"
					style={{ width: "10rem", height: "15.625rem", marginBottom: "1rem" }}
				/>

				<span style={{ fontWeight: "bold" }}>Setting up your SEE Learning Portal...</span>
			</Column>
		</OnboardingLayout>
	);
}
